import { later } from '@ember/runloop';

// options.onUpdate: callback sent after state of dropdown is updated

export const installDropdown = (component, refFieldName, options = {}) => {
  const setDropdownRef = (value) => {
    if (value) {
      component[refFieldName] = value;
      options.onUpdate?.(value);
    } else {
      if (component[refFieldName]) {
        if (typeof component[refFieldName] === 'function') {
          component[refFieldName]();
        }

        later(() => {
          component[refFieldName] = false;
          options.onUpdate?.(false);
        }, 150);
      }
    }
  };

  // when there are more than 1 dropdown installed within a component we need
  // to specify separate reference functions for each dropdown, custom name is needed for each of them
  const refFunctionName = options.refFunctionName || 'setDropdownRef';

  component[refFunctionName] = setDropdownRef;
};